import { useEditContext } from '@components/utils/contexts/EditContext';
import InternalLink from '@components/utils/links/internalLink';
import { ROUTE_PRODUCT } from '@constants';
import { EmbedPostMessageAction } from '@lib/embed/enums';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { postMessageToEmbed } from '@lib/embed/utils/postMessageToEmbed';
import { IconButton, IconButtonProps } from '@lib/uikit';
import { useRouter } from 'next/router';
import { FC } from 'react';

export const ExitButton: FC = () => {
    const { query } = useRouter();
    const { isEditMode } = useEditContext();
    const { isEmbedContextLoading, isStoryBundle } = useEmbedContext();

    if (isEditMode || isEmbedContextLoading) return null;

    const props: IconButtonProps = {
        ariaLabel: 'Close',
        icon: 'close',
        color: 'white',
        buttonSize: 'large',
    };

    if (isStoryBundle) {
        return (
            <IconButton
                {...props}
                onClick={() =>
                    postMessageToEmbed(EmbedPostMessageAction.DIALOG_CLOSE)
                }
            />
        );
    }

    return (
        <IconButton
            as={InternalLink}
            {...(props as IconButtonProps<typeof InternalLink>)}
            href={{ pathname: ROUTE_PRODUCT, query }}
            linkAs={`/${query.product}`}
        />
    );
};
